/// <reference types="@types/heremaps" />
import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsDataService} from '../settings-data.service';
import {LOCAL_STORAGE, StorageService} from 'angular-webstorage-service';
import {Vehiclecontainer} from '../model/vehiclecontainer.model';
import {Point} from '../model/point.model';
import {MatSnackBar} from '@angular/material';
import {forkJoin, Observable} from 'rxjs';
import {TrackVehicle} from '../model/track-vehicle.model';
import {map} from 'rxjs/operators';
import {HereMapConverter} from '../model/here-map-converter';

const H = window['H'];

// storage keys for map
const STORAGE_MAP_VIEWBOUNDS = 'local_map_bounds';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit {
  @ViewChild('map', { static: true }) mapContainer: ElementRef;

  hmap: H.Map;
  ui: H.ui.UI;

  vehicleGroup: H.map.Group;
  routeStops: H.map.Group;
  routeShape: H.map.Group;
  pinnedStops: H.map.Group;
  highlightCenter: H.map.Group;
  trackVehicleEnabled = false;
  trackVehicleCenter: H.map.Group;
  trackVehicleAndCenter: H.map.Group;

  bubble: H.ui.InfoBubble;
  loading: boolean;

  trackVehicle: TrackVehicle = null;

  constructor(private http: HttpClient, private settingsDataService: SettingsDataService,
              @Inject(LOCAL_STORAGE) private storage: StorageService, private snackBar: MatSnackBar) {
    this.settingsDataService.routeAdded.subscribe(any => this.reloadData(true));
    this.settingsDataService.routeRemoved.subscribe(any => this.reloadData(false));
    this.settingsDataService.minZoomLevelModified.subscribe(any => this.reloadData(false));
    this.settingsDataService.iconSizeModified.subscribe(any => this.reloadData(false));
    this.settingsDataService.refreshAll.subscribe(any => this.refreshMap());
    this.settingsDataService.stopsModified.subscribe(any => this.updatePinnedStops());
    this.settingsDataService.moveMapToPoint.subscribe(item => this.moveToPoint(item));
    this.settingsDataService.trackVehicle.subscribe(item => {
      this.trackVehicle = item;
      this.trackVehicleEnabled = true;
    });

    this.loading = false;
  }

  ngOnInit() {
    this.initializeMap();
    this.reloadData(false);
  }

  private reloadData(recenterBounds: boolean) {
    console.log('recenter: ', recenterBounds);

    this.vehicleGroup.removeAll();
    this.routeStops.removeAll();
    this.routeShape.removeAll();
    // refresh route shapes, stops
    if (this.settingsDataService.routes.length > 0) {

      this.settingsDataService.routes.forEach(route => {
        const routeShape = this.settingsDataService.getRouteShape(route.providerId, route.routeId);
        if (routeShape !== null && routeShape !== undefined) {

          if (this.settingsDataService.zoomLevel <= 20) {
            const stops = HereMapConverter.getStops(routeShape, this.settingsDataService.iconSize, this.settingsDataService.zoomLevel);
            if (stops !== null && stops !== undefined && stops.length > 0) {
              this.routeStops.addObjects(stops);
            }
          }
          const shape = HereMapConverter.getShape(routeShape);
          if (shape !== null && shape !== undefined && shape.length > 0) {
            this.routeShape.addObjects(shape);
          }
        }
      });

      if (recenterBounds && this.routeShape.getBoundingBox() !== null && this.routeShape.getBoundingBox() !== undefined) {
        this.hmap.getViewModel().setLookAtData({bounds: this.routeShape.getBoundingBox()});
      }
    }

    this.updatePinnedStops();
    this.refreshMap();

  }

  private refreshMap() {

    if (this.settingsDataService.routes.length > 0) {
      console.log('refresh: true');
      this.loading = true;

      const urls: Observable<Object>[] = [];
      this.settingsDataService.routes.forEach(route => {
        if (this.trackVehicle === null || this.trackVehicle === undefined || this.trackVehicle.routeId.localeCompare(route.routeId) === 0) {
          urls.push(this.http.get(`https://ShowMeMyCommute.com:5928/` +
            `getVehiclesForRoute?providerId=${route.providerId}&routeId=${route.routeId}&clientId=${this.settingsDataService.identifier}`));
        }

      });

      if (urls.length === 0) {
        this.loading = false;
        this.vehicleGroup.removeAll();
      }

      forkJoin(urls).subscribe(results => {
        const newVehicles = [];

        results.forEach(r => {
          const vehicle = new Vehiclecontainer();
          vehicle.deserialize(r);
          HereMapConverter.getMarkers(vehicle, this.settingsDataService.iconSize,
            this.settingsDataService, this.trackVehicleEnabled, this.trackVehicle)
            .forEach(v => {
              newVehicles.push(v);
            });
        });

        this.loading = false;
        this.vehicleGroup.removeAll();
        this.vehicleGroup.addObjects(newVehicles);
        console.log('refresh: false' + newVehicles.length);
      }, err => {
        this.loading = false;
      });
    }

    if (this.trackVehicle !== null) {
      // track vehicle and move
      this.http.get(`https://ShowMeMyCommute.com:5928` +
        `/getVehicle?vehicleId=${this.trackVehicle.vehicleId}&providerId=${this.trackVehicle.provider}`)
        .pipe(map(res => new Vehiclecontainer().deserialize(res)))
        .subscribe(vc => {
          this.trackVehicleCenter.removeAll();


          if (vc !== null && vc !== undefined && vc.veh.length > 0) {
            const lastVeh = vc.veh[vc.veh.length - 1];

            this.trackVehicleCenter.addObjects(HereMapConverter.getMarkers(vc, this.settingsDataService.iconSize,
              this.settingsDataService, false, null));
            this.trackVehicleCenter.addObject(
              new H.map.Marker({lat: lastVeh.lat, lng: lastVeh.lon}, {
                icon: new H.map.Icon(`<svg xmlns="http://www.w3.org/2000/svg"
      width="64px" height="64px">
      <rect width="64px" height="64px"
      stroke="red" stroke-width="10px" fill-opacity="0.5" fill="red" />
      </svg>`, {
                  anchor: {x: 32, y: 32},
                  zIndex: 10,
                  crossOrigin: false
                })
              })
            );

            const cameraData = this.hmap.getViewModel().setLookAtData({ bounds: this.trackVehicleAndCenter.getBoundingBox()});

            if (cameraData.getZoom() < (this.hmap.getZoom() + 1)) {
              this.hmap.setZoom(cameraData.getZoom() - 1, true);
            }
            this.hmap.setCenter(cameraData.getLookAtData().position, true);
          }


        }, err => {
          console.log(err);
        });
    }

  }

  private initializeMap() {

    const platform = new H.service.Platform({
      'apikey': 'zvKFW4uWXfzS5jNDu7VieH_vsuOi0McWaPgkEuK7nus'
    });
    const defaultLayers = platform.createDefaultLayers({
      tileSize: 256 > 1 ? 512 : 256,
      ppi: devicePixelRatio > 1 ? 320 : 72
    });
    const layers = platform.createDefaultLayers();
    this.hmap = new H.Map(
      this.mapContainer.nativeElement,
      (layers as any).vector.normal.map,
      {
        pixelRatio: Math.min(2, devicePixelRatio),
      }
    );

    const bounds = this.storage.get(STORAGE_MAP_VIEWBOUNDS) || {top: 40.68, left: -74.145, bottom: 40.78, right: -73.92};

    this.hmap.getViewModel().setLookAtData({bounds: new H.geo.Rect(bounds.top, bounds.left, bounds.bottom, bounds.right)});

    const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.hmap));
    this.ui = H.ui.UI.createDefault(this.hmap, defaultLayers);

    this.hmap.addEventListener('mapviewchangeend', () => {
      this.settingsDataService.activityDetected.emit('mapviewchangeend');
      // save current bounds
      const viewBounds = this.hmap.getViewModel().getLookAtData().bounds.getBoundingBox();
      this.storage.set(STORAGE_MAP_VIEWBOUNDS, {
        top: viewBounds.getTopLeft().lat,
        left: viewBounds.getTopLeft().lng,
        bottom: viewBounds.getBottomRight().lat,
        right: viewBounds.getBottomRight().lng
      });
    });

    this.hmap.addEventListener('dragstart', evt => {
      this.mapMoved();
    });

    this.hmap.addEventListener('tap', evt => {
      this.mapMoved();
      this.settingsDataService.activityDetected.emit('tap');
      // @ts-ignore
      const coords = this.hmap.screenToGeo(evt.currentPointer.viewportX, evt.currentPointer.viewportY);

      let minDist = 1500;
      let nearest_text = '*None*';
      let markerDist = minDist;
      // get all objects added to the map
      let stops: H.map.Marker[];
      let pinnedstops: H.map.Marker[];
      let marker: H.map.Marker = null;
      stops = <H.map.Marker[]>this.routeStops.getObjects();
      pinnedstops = <H.map.Marker[]>this.pinnedStops.getObjects();

      let markercoords: any = null;
      let pinnedFound = false;

      // iterate over objects and calculate distance between them
      for (let i = 0; i < stops.length; i += 1) {
        markerDist = stops[i].getGeometry().getBoundingBox().getCenter().distance(coords);
        if (markerDist < minDist) {
          markercoords = stops[i].getGeometry();
          marker = stops[i];
          minDist = markerDist;
          nearest_text = stops[i].getData();
        }
      }

      if (this.ui.getMap().getZoom() < this.settingsDataService.zoomLevel) {
        minDist = 1500;
      }


      // iterate over objects and calculate distance between them
      for (let i = 0; i < pinnedstops.length; i += 1) {
        markerDist = pinnedstops[i].getGeometry().getBoundingBox().getCenter().distance(coords);
        if (markerDist < minDist) {
          marker = pinnedstops[i];
          minDist = markerDist;
          nearest_text = pinnedstops[i].getData();
          pinnedFound = true;
        }
      }

      if (!pinnedFound && marker !== null && this.ui.getMap().getZoom() < this.settingsDataService.zoomLevel &&
        markercoords !== null && this.settingsDataService.shouldZoom()) {
        this.hmap.setCenter(markercoords, true);
        this.hmap.setZoom(15, true);
        this.snackBar.open(
          'Zoom in to see more stops',
          'Ok', {duration: 5000});
      }

      // @ts-ignore
      if (marker !== null && marker !== undefined) {
        this.settingsDataService.updateStopID(marker.getData().stopId, marker.getData().providerId, marker.getData().route);
        this.refreshMap();
        /* UI bubble is annoying
        if (this.bubble !== null) {
          this.ui.removeBubble(this.bubble);
        }
        this.bubble = new H.ui.InfoBubble(marker.getPosition(),
          {content: `<p style="font-size:x-small; ">${marker.getData().stopId} - ${marker.getData().stopDescription}</p>`}
        );

        this.ui.addBubble(this.bubble);
        */

        this.highlightCenter.removeAll();
        this.highlightCenter.addObject(
          new H.map.Marker(marker.getGeometry(), {
            icon: new H.map.Icon(`<svg xmlns="http://www.w3.org/2000/svg"
      width="64px" height="64px"><circle cx="32px" cy="32px"
      r="32px" stroke="black" fill-opacity="0.5" fill="green" /></svg>`, {
              zIndex: 10,
              crossOrigin: false
            })
          })
        );
      }

    }, false);


    this.vehicleGroup = new H.map.Group();
    this.routeStops = new H.map.Group();
    this.routeShape = new H.map.Group();
    this.pinnedStops = new H.map.Group();
    this.highlightCenter = new H.map.Group();
    this.trackVehicleCenter = new H.map.Group();

    this.trackVehicleAndCenter = new H.map.Group();
    this.trackVehicleAndCenter.addObject(this.highlightCenter);
    this.trackVehicleAndCenter.addObject(this.trackVehicleCenter);

    this.hmap.addObjects([this.vehicleGroup, this.routeStops,
      this.routeShape, this.pinnedStops, this.trackVehicleAndCenter]);

  }

  private updatePinnedStops() {
    const newPins = [];
    this.settingsDataService.stops.forEach(stop => {
      newPins.push(HereMapConverter.getStopPinnedMarker(stop, this.settingsDataService.iconSize));
    });


    this.pinnedStops.removeAll();
    this.pinnedStops.addObjects(newPins);
  }

  private moveToPoint(item: Point) {

    this.highlightCenter.removeAll();
    this.hmap.setCenter({lat: item.lat, lng: item.lon}, true);
    this.highlightCenter.addObject(
      new H.map.Marker({lat: item.lat, lng: item.lon}, {
        icon: new H.map.Icon(`<svg xmlns="http://www.w3.org/2000/svg"
      width="${this.settingsDataService.iconSize * 1.5}em"
      height="${this.settingsDataService.iconSize * 1.5}em">
      <circle cx="${this.settingsDataService.iconSize * 1.5 / 2}em"
      cy="${this.settingsDataService.iconSize * 1.5 / 2}em"
       r="${this.settingsDataService.iconSize * 1.5 / 2}em" stroke="black" fill-opacity="0.5" fill="green" /></svg>`, {
          anchor: {x: 32, y: 32},
          zIndex: 10,
          crossOrigin: false
        })
      })
    );
  }

  private mapMoved() {
    if (this.trackVehicleEnabled) {
      this.trackVehicle = null;
      // this.highlightCenter.removeAll();
      this.trackVehicleCenter.removeAll();
      this.trackVehicleEnabled = false;
      this.refreshMap();
    }

    this.trackVehicle = null;
    // this.highlightCenter.removeAll();
    this.trackVehicleCenter.removeAll();
    this.trackVehicleEnabled = false;
  }
}
